import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["question", "profiles", "plannerProfile", "adventurerProfile"]

  connect() {
    // Initialisation : cacher les profils mais pas la question
    this.profilesTarget.classList.add('hidden')
    this.plannerProfileTarget.classList.add('hidden')
    this.adventurerProfileTarget.classList.add('hidden')
  }

  showProfile(event) {
    const profileType = event.currentTarget.dataset.profileType
    
    // Masquer la question avec transition
    this.questionTarget.classList.add('opacity-0')
    
    setTimeout(() => {
      // Cacher la question
      this.questionTarget.classList.add('hidden')
      
      // Afficher la section des profils
      this.profilesTarget.classList.remove('hidden')
      
      // Afficher le profil sélectionné
      if (profileType === 'planner') {
        this.plannerProfileTarget.classList.remove('hidden')
        this.adventurerProfileTarget.classList.add('hidden')
      } else {
        this.adventurerProfileTarget.classList.remove('hidden')
        this.plannerProfileTarget.classList.add('hidden')
      }
      
      // Animer l'apparition
      requestAnimationFrame(() => {
        this.profilesTarget.classList.remove('opacity-0')
      })
    }, 300)
  }

  reset() {
    // Masquer les profils
    this.profilesTarget.classList.add('opacity-0')
    
    setTimeout(() => {
      // Cacher tous les profils
      this.profilesTarget.classList.add('hidden')
      this.plannerProfileTarget.classList.add('hidden')
      this.adventurerProfileTarget.classList.add('hidden')
      
      // Réafficher la question
      this.questionTarget.classList.remove('hidden')
      requestAnimationFrame(() => {
        this.questionTarget.classList.remove('opacity-0')
      })
    }, 300)
  }
} 